module.exports = __webpack_public_path__ + "img/laporan_data.e376d59c.png";